export const isImageFile = (f: File | null): f is File => !!f && !!f.type && f.type.startsWith('image/');

/** Clipboard/DataTransfer *items* → image Files (via getAsFile) */
export const getImageFilesFromItems = (items?: DataTransferItemList): File[] => {
  if (!items) return [];
  const out: File[] = [];
  for (let i = 0; i < items.length; i++) {
    const it = items[i];
    if (it.kind === 'file' && it.type.startsWith('image/')) {
      const f = it.getAsFile();
      if (isImageFile(f)) out.push(f);
    }
  }
  return out;
};

/** FileList → image Files (filters by MIME) */
export const getImageFilesFromFileList = (list?: FileList): File[] => {
  if (!list) return [];
  const out: File[] = [];
  for (let i = 0; i < list.length; i++) {
    const f = list[i];
    if (isImageFile(f)) out.push(f);
  }
  return out;
};
